import { requestGet, requestPost } from '@/common/request';
import apis from '@/apis';

const origin = 'http://10.170.131.196/mock/5ed46ed3393ecd00365fca1a';

export default {
  async fetchMyActivityList(query) {
    return await requestGet(origin + '/acore/myactivity', query);
  },
  async fetchActivityDetail(query) {
    // return await requestGet(origin + '/acore/getActivityDetail', query)
    return apis.fetchActivityDetail(query);
  },
  async fetchCheckList(query) {
    return await requestGet('https://yfemocks.jd.com/mock/5ed46ed3393ecd00365fca1a/acore/resources/examineList', query);
  },
  async fetchCheck(query) {
    return await requestPost(
      'https://yfemocks.jd.com/mock/5ed46ed3393ecd00365fca1a/acore/resource/firstExamineResource',
      query
    );
  },
};
